module.exports = __webpack_public_path__ + "fonts/helvetica_neu_bold-webfont.4e7fb5d5.woff2";